import { Service } from '@tino-frontend/adapters'
import {
  BillLimitReservation,
  CancelLimitReservation,
  ConfirmLimitReservation,
  LimitReservationsResponse,
} from '@types'

export class LimitReservationsService {
  constructor(private readonly http: Service) {}

  getTotal(supplier_company_id: string): Promise<LimitReservationsResponse> {
    return this.http.get('/v1/limit-reservations', {
      params: { supplier_company_id },
    })
  }

  cancel({ limit_reservation_id, supplier_id }: CancelLimitReservation) {
    return this.http.delete(`/v1/limit-reservations/${limit_reservation_id}`, {
      params: {
        supplier_id,
      },
    })
  }

  bill({ limit_reservation_id, ...payload }: BillLimitReservation) {
    return this.http.postForm(
      `/v1/limit-reservations/${limit_reservation_id}/bill`,
      payload
    )
  }

  confirm({ limit_reservation_id, accept }: ConfirmLimitReservation) {
    return this.http.post(
      `/v1/limit-reservations/${limit_reservation_id}/confirm`,
      {
        accept,
      }
    )
  }
}
